import { Stack, Text } from '@chakra-ui/react'

import { IAdmissionDocumentRaw, IAdmissionVacancyRaw } from '../../../../services/Admission/types'
import AdmissionDocumentField from '../AdmissionDocumentField'
import { TFormErrors } from '../admissionForm'

interface IDocumentsStepProps {
  token: string
  vacancy: IAdmissionVacancyRaw | undefined
  documents: IAdmissionDocumentRaw[]
  onUploaded: (document: IAdmissionDocumentRaw) => void
  onRemoved: (documentId: number) => void
  errors: TFormErrors
  isDisabled: boolean
}

/** The documents the chosen role asks for; the required ones hold the submission back. */
export default function DocumentsStep({
  token,
  vacancy,
  documents,
  onUploaded,
  onRemoved,
  errors,
  isDisabled
}: IDocumentsStepProps) {
  // The vacancy left the open list (it closed while the page was open): the documents depend on it.
  if (!vacancy) {
    return <Text>Não encontramos a vaga escolhida. Volte em Informações profissionais e escolha de novo.</Text>
  }

  if (vacancy.documents.length === 0) {
    return <Text>Este cargo não pede documentos. Revise seus dados e envie a admissão.</Text>
  }

  return (
    <Stack spacing={6}>
      <Text variant="caption">Um arquivo por documento. Cada arquivo é enviado assim que você o escolhe.</Text>
      {vacancy.documents.map((requirement) => (
        <AdmissionDocumentField
          key={requirement.id}
          token={token}
          requirement={requirement}
          uploaded={documents.find((document) => document.job_position_document_id === requirement.id)}
          onUploaded={onUploaded}
          onRemoved={onRemoved}
          error={errors[`documents.${requirement.id}`]}
          isDisabled={isDisabled}
        />
      ))}
    </Stack>
  )
}
